/**
 * Prevents zooming on iOS
 */
import Vue from 'vue';

Vue.directive('no-dbl-tap-zoom', {
  bind: function(el) {
    el.preventDblTapEnd = false;
    el.noDblTapZoom = function(e) {
      var t2 = e.timeStamp;
      var t1 = el.dblTapLastTouch || t2;
      var dt = t2 - t1;
      var fingers = e.originalEvent.touches.length;
      el.dblTapLastTouch = t2;
      if (!dt || dt > 500 || fingers > 1) {
        // This is not a double tap
        return;
      }
      // This is a double tap, prevent zooming
      e.preventDefault();
      el.preventDblTapEnd = true;
      // Trigger click to replace touch
      $(e.target).trigger('click');
    };
    el.noDblTapZoomEnd = function(e) {
      if (el.preventDblTapEnd) {
        e.preventDefault();
        el.preventDblTapEnd = false;
      }
    };
    $(el).on('touchstart', el.noDblTapZoom);
    $(el).on('touchend', el.noDblTapZoomEnd);
  },
  unbind: function(el) {
    $(el).off('touchstart', el.noDblTapZoom);
    $(el).off('touchend', el.noDblTapZoomEnd);
  }
});
